"use strict";
import React from "react";
import { Link } from "react-router-dom";
import FormsyFields from "./formsyFields";
import Formsy from "./formsy";
import FormsyFormErrorsProvider from "./formsyFormErrorsProvider";
import FormError from "./formError";
import FormsyInputInteractive from './prism/FormsyElements/FormsyInputInteractive';
import PrismIcon from "./prism/icon/prismIcon";

const initComponent = (flex = window.flex) => {

    class Login extends React.PureComponent {
        constructor(props){
            super(props);

            const usernameRemembered = this.getUsernameFromStorage();
            
            this.state = {
                canSubmit: false,
                rememberMyUsername: !!usernameRemembered,
                usernameRemembered
            };
        }

        enableButton = () => {
            this.setState({
                canSubmit: true
            });
        };

        disableButton = () => {
            this.setState({
                canSubmit: false
            });
        };

        handleLogin = (model, reset, invalidate, addFormErrors, clearFormErrors) => {
            flex.setBusy("global:login", true);

            const { rememberMyUsername, usernameRemembered } = this.state;
            const { saveUsernameToStorage } = this;
            var activeSpinner = flex.showSpinner(document.querySelector('.ladda-button'));

            $.ajax({
                url: flex.getApiUrl("/api/v1/auth/authenticateuser"),
                async: true,
                type: "POST",
                dataType: "json",
                contentType: "application/json",
                data: JSON.stringify({ username: model.username, password: model.password }),
                headers: flex.getHeaders(),
                success: function (data) {
                    clearFormErrors();
                    flex.setBusy("global:login", false);

                    if (!data || !data.session || !data.isValid) {
                        // Handle errors
                        if (data.redirectUrl && data.redirectUrl !== '') {
                            flex.redirect(data.redirectUrl);
                            return;
                        }

                        invalidate({
                            password: flex.text("UX_LOGIN_MSG_INVALID")
                        });
                        return;
                    }

                    if (rememberMyUsername) {
                        saveUsernameToStorage(model.username);
                    }
                    else if (usernameRemembered === model.username)
                    {
                        saveUsernameToStorage("");
                    }

                    // Get redirect url
                    var redirectUrl = flex.getRedirectUrl() || "/";

                    // Notify store of new session, then redirect
                    flex.trigger("global:session-loggedin", { session: data.session, then: () => { flex.redirect(redirectUrl); } });
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    let issues = [];

                    if (jqXHR.responseJSON && jqXHR.responseJSON.dealerIssues) {
                        issues = issues.concat(jqXHR.responseJSON.dealerIssues);
                    }
                    
                    if (jqXHR.responseJSON && jqXHR.responseJSON.personIssues) {
                        issues = issues.concat(jqXHR.responseJSON.personIssues);
                    }

                    console.log(issues);
                    if (issues) {
                        issues.forEach((issue) => {
                            console.log("ISSUE", issue);
                            if (issue.displayMessage) {
                                if (issue.personIssueAffectsAllDealerships === "Block") {
                                    flex.addPageAlerts({ kind: "api-exception", className: "alert-danger", summary: issue.displayMessage });
                                }
                                else {
                                    flex.addPageAlerts({ kind: "api-exception", className: "alert-info", summary: issue.displayMessage });
                                }
                            }
                        });
                    }

                    if ([0, 404, 500, 503].includes(jqXHR.status)) {
                        const errorMsg = `Something Went Wrong. ${flex.text("UX_CONTACT_CLIENT_CARE", "For assistance, please contact Client Care")}`;
                        addFormErrors({ formError: [ errorMsg ] });
                    } else {
                        flex.handleAjaxError(jqXHR, textStatus, errorThrown, addFormErrors);
                    }
                    flex.setBusy("global:login", false);
                    flex.hideSpinner(activeSpinner);
                    return;
                }
            });
        };

        handleChangeUsername = (e) => {
            this.setState({ username: e.target.value })
        };

        handleChangePassword = (e) => {
            this.setState({ password: e.target.value })
        };

        onRememberMyUsername = (name, value) => {
            this.setState({
                rememberMyUsername: value
            });
        }

        getUsernameFromStorage = () => {
            return localStorage.getItem("username");
        }

        saveUsernameToStorage = (usernameToRemember) => {
            localStorage.setItem("username", usernameToRemember);
        }

        render() {
            const formProps = {
                layout: "vertical",
                changeDebounceInterval: 0 // Fix issue with auto tests when value of input is refreshing to default
            };

            const { usernameRemembered } = this.state;

            const usernameLabel = flex.text("UX_LOGIN_LBL_USERNAME");
            const passwordLabel = flex.text("UX_LOGIN_LBL_PASSWORD");
            const forgotPasswordText = flex.text("UX_LOGIN_ACT_FORGOTPASSWORD");
            const loginHeader = flex.text("UX_LOGIN_HDR_LOGIN");

            return (
                <div className="login-page">
                    <section className="container" role="main">
                        <div className="row">
                            <FormsyFormErrorsProvider>
                                <Formsy.Form id="login-form" ref="loginform" className="login-form validate-form col-sm-6 col-sm-offset-3" onValidSubmit={this.handleLogin} onValid={this.enableButton} onInvalid={this.disableButton}>
                                    <div className="row">
                                        <div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">
                                            <FormError name="formError" />
                                        </div>
                                    </div>

                                    <div className="form-group text row">
                                        <div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 hideFormsy">
                                            <FormsyInputInteractive
                                                {...formProps}
                                                iconLeft="prism-icon-user icon"
                                                id="username"
                                                name="username"
                                                autoComplete="off"
                                                value={usernameRemembered}
                                                placeholder={usernameLabel}
                                                required={true}
                                                validations="minLength:1"
                                                validationError="Username is required"
                                                type="text"
                                                autoFocus={!usernameRemembered}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group text row">
                                        <div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 hideFormsy">
                                            <FormsyInputInteractive
                                                iconLeft="prism-icon-locked icon"
                                                id="password"
                                                name="password"
                                                placeholder={passwordLabel}
                                                type="password"
                                                value=""
                                                required={true}
                                                validationError="Password is required"
                                                autoFocus={!!usernameRemembered}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group text row">
                                        <div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">
                                            <flex.components.StyledCheckbox
                                                {...formProps}
                                                id="rememberMyUsername"
                                                name="rememberMyUsername"
                                                label="Remember my Username"
                                                onChange={this.onRememberMyUsername}
                                                value={!!usernameRemembered}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">
                                            <button 
                                                className="btn ladda-button" 
                                                data-style="expand-right" 
                                                type="submit" 
                                                disabled={!this.state.canSubmit || flex.isBusy("global:login")}>
                                                {flex.text("UX_LOGIN_ACT_LOGIN")}
                                            </button>
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <div className="col-sm-6 col-sm-offset-3">
                                            <p>
                                                {flex.text("UX_LOGIN_LBL_LOGIN_HELP")}
                                            </p>
                                        </div>
                                    </div>

                                    <hr />

                                    <div className="form-group text row login-page__forgot-section-wrapper">
                                        <div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">
                                            <label className="float-left">Forgot?</label>
                                            <Link className="float-right" to="/forgotpassword"><PrismIcon glyph="locked"/>&nbsp;Password</Link>
                                            <Link className="float-right" to="/forgotusername"><PrismIcon glyph="user"/>&nbsp;Username</Link>
                                        </div>
                                    </div>
                                </Formsy.Form>
                            </FormsyFormErrorsProvider>
                        </div>
                    </section>
                </div>
            );
        }
    }

    return Login;
};

module.exports = initComponent;
